const trimUrl = (value: string | undefined): string => (value || "").trim().replace(/\/+$/, "");

/**
 * nxivo-admin endpoints for SSO. The localhost defaults only apply when Bindley itself runs on
 * localhost; deployed builds without explicit URLs return null so browsers never probe the
 * visitor's own machine.
 */
export function resolveNxivoAdmin(): { api: string; web: string } | null {
  const api = trimUrl(process.env.REACT_APP_NXIVO_ADMIN_API_URL);
  const web = trimUrl(process.env.REACT_APP_NXIVO_ADMIN_URL);
  const isLocalHost = typeof window !== "undefined" && ["localhost", "127.0.0.1"].includes(window.location.hostname);
  if (api) return { api, web: web || api };
  if (isLocalHost) return { api: "http://localhost:3100", web: web || "http://localhost:5180" };
  return null;
}
